import Typography from '@mui/material/Typography';
import { useAppSelector } from 'redux/hooks';
import _ from 'lodash';

import AddSetButton from 'pages/BuoyData/SideDrawer/AddSetButton';
import SensorDetails from 'pages/BuoyData/SideDrawer/SensorDetails';
import SetCard from 'pages/BuoyData/SideDrawer/SetCard';
import GetDataButton from 'pages/BuoyData/SideDrawer/GetDataButton';
import ChartOptions from './Graph/ChartOptions';

export default function MobileBuoyData() {
  const cardSet: any[] = useAppSelector(
    (state) => state.datasetCardController.set
  );

  function generateSetCard() {
    return cardSet.map((item: any, index) => (
      <SetCard
        key={index}
        index={index.toString()}
        location={item.location}
        depth={item.depth}
        depths={item.depths}
        parameter={item.parameterDesc}
        mobile
      />
    ));
  }

  return (
    <div style={{ paddingBottom: 100 }}>
      {/** Option drawer */}
      {
        <div style={{ padding: 32, paddingBottom: 0 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <Typography variant='body_large_strong' color='blue.900'>
              Data
            </Typography>
            <SensorDetails isMobile={true} />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: 12
            }}
          >
            {generateSetCard()}
            <div style={{ marginTop: 24, display: 'flex' }}>
              <AddSetButton mobile />
              <div style={{ width: 24 }} />
              <GetDataButton disabled={cardSet.length === 0} />
            </div>
          </div>
        </div>
      }

      {/** Chart option */}
      {<ChartOptions mobile />}
    </div>
  );
}
